// import { Dammcode, DammError } from "./damm.ts";
//
// export class InvalidShelcode extends DammError {
//   constructor(msg?: string) {
//     let fullMessage = "Invalid shelcode";
//     if (msg) {
//       fullMessage += ": " + msg;
//     }
//     super(fullMessage);
//     Object.setPrototypeOf(this, InvalidShelcode.prototype);
//   }
// }
//
// export class Shelcode extends Dammcode {
//   protected override validate(): void {
//     super.validate();
//     if (this.digits.length != 10) throw new InvalidShelcode(`bad length, expected 10 digits but got ${this.digits.length} digits`);
//     if (this.digits[0] !== 5) throw new InvalidShelcode();
//     if (this.digits[1] !== 4) throw new InvalidShelcode();
//     if (this.digits[2] !== 1) throw new InvalidShelcode();
//   }
// }

export function validShelcode(code: string): boolean {
  if (!/^541[0-9]{7}$/.test(code)) return false;
  if (parseInt(code)%97 != 1) return false;
  return true;
}

/** Given the _id of a shelcode: doc (e.g. "shelcode:54100000"), compute the
 *  full 10-digit shelcode with mod-97 check digits appended. */
export function computeShelcode(shelcodeDocId: string): string {
  const prefix = shelcodeDocId.replace(/^shelcode:/, "");
  const base = parseInt(prefix + "00", 10);
  return String(base + (98 - (base % 97)));
}
